import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'

const Page = ({ data }) => (
	<Layout>
		<Seo
			title="Sample page"
			keywords={[`blog`, `gatsby`, `javascript`, `react`]}
		/>
		<div className="inner-wrap-container">
			<div className="inner-wrap visible animate fade-in">
				<div className="single-article">
					{/* OPTIONAL: Featured Image: */}
					<div
						className="featured-image"
						style={{
							backgroundImage: `url(${data.bg.childImageSharp.fluid.src})`,
						}}
					/>
					{/* OPTIONAL: Featured Image: */}

					<div className="post-content m-auto">
						<h1 className="title">Sample Page</h1>
						<div className="content">This is a sample page.</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
)

const pageQuery = graphql`
	query {
		bg: file(absolutePath: { regex: "/fabio-comparelli/" }) {
			childImageSharp {
				fluid(maxWidth: 1024) {
					...GatsbyImageSharpFluid
				}
			}
		}
	}
`

export default () => (
	<StaticQuery query={pageQuery} render={data => <Page data={data} />} />
)
